import { StyleSheet } from 'react-native';
const ls = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#f5f5f5',
  },
  title: {
    fontSize: 20,
    marginBottom: 20,
    fontWeight: 'bold',
  },
  otpContainer: {
    flexDirection: 'row',
  },
  otpInput: {
    width: 44,
    height: 60,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    fontSize: 15,
    marginHorizontal: 5,
    textAlign: 'center',
    outlineStyle:'none'
  },
  resendContainer: {
    marginVertical: 10,
    height: 30,
  },
  timerText: {
    color: '#888',
  },
  resendText: {
    color: '#1434cb',
    fontWeight: 'bold',
  },
  verifyButton: {
    backgroundColor: '#007bff',
    padding: 15,
    borderRadius: 10,
    width: '100%',
    alignItems: 'center',
  },
  verifyButtonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  errorMessage: {
    color: 'rgb(240, 68, 56)',
    fontFamily: 'Inter',
    fontSize: 12,
  },
  disableResend: {
    color: '#667085',
  },
  otpsucceess: {
    color: 'green',
  },
});
export default ls;
